var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.654,
    height: 23.704,
    viewBox: "0 0 41.654 23.704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #4eb2a2;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(1 0.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0 0.15)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    className: "cls-1",
    x2: 32.935,
    transform: "translate(0 10.77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42528",
    "data-name": "Path 42528",
    className: "cls-1",
    d: "M10.93,2.92,14.213,6.2,10.93,9.458",
    transform: "translate(18.723 4.595)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42529",
    "data-name": "Path 42529",
    className: "cls-1",
    d: "M7.81,3.27a10.852,10.852,0,1,1,0,15.464",
    transform: "translate(13.378 -0.15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow_icon.36fcceefcff4109cbf0d802a8e39b607.svg";
export { ForwardRef as ReactComponent };